<template>
  <div>
    <div class="flex items-center justify-between">
      <div
        class="rotate-icon opacity-0 group-hover:opacity-100 anim-opacity"
        :class="{'opacity-100': activeIndex}"
      >
        <i class="icon-arrow-up text-19 font-bold text-dark-600" />
      </div>
      <p>{{ item.subTitle }}</p>
      <p>highlight</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    item: Object,
    activeIndex: Boolean
  },

  setup () {
    return {
      // ref
      // data
      // computed
      // function
    }
  }
})
</script>
